export default {
  name: "Dialog",
  props: {
    dialogShow: {
      type: Boolean
    },
    title: {
      type: String
    },
    showCancelBtn: {
      type: Boolean,
      default: false
    },
    showConfirmBtn: {
      type: Boolean,
      default: false
    },
    key: {
      type: String
    }
  },
  methods: {
    clickMask: function clickMask() {
      this.$emit('clickMask');
    }
  }
};